<template>
    <sub-page>
        <div class="m-livePublish"
             v-loading="loading"
             element-loading-background="#2D2D2D"
        >
            <iframe class="live-frame" :src="liveUrl" allow="camera *;microphone *;display-capture" border="0" allowfullscreen='true'></iframe>

            <div class="error" v-if="loadFailed">
                <p><i class="nucfont inuc-host"></i>直播加载失败~</p>
                <a class="btn-refresh" @click="refreshPage" :title="$t('live.reload')"><i class="el-icon-refresh refresh-icon"></i></a>
            </div>
        </div>
    </sub-page>

</template>

<script>
export default {
    props: {
        id: {},
    },

    components: {},

    data() {
        return {
            liveUrl: '',
            loading: true,
            loadFailed: false,
        }
    },

    computed: {

    },

    mounted() {

        console.log(this.id)
        this.getLiveUrl()
    },

    methods: {
        getLiveUrl() {
            this.$api.getLiveStartUrl(this.id).then(res => {
                this.liveUrl = res.package
            }).catch(() => {
                this.loadFailed = true
            }).finally(() => {
                this.loading = false
            })

            console.log(this.liveUrl)
        },

        refreshPage() {
            history.go(0)
        }
    },
}
</script>

<style lang="scss">
    .sub-page {
        //position: fixed;
        //top: 0;
        //left: 0;
        //right: 0;
        //bottom: 0;
        .m-livePublish {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }

    .m-livePublish {
        height: 100%;
        background-color: #2D2D2D;
        //position: fixed;
        //top: 0;
        //left: 0;
        //right: 0;
        //bottom: 0;

        .el-loading-spinner {
            margin-top: -25px;
            .circular {
                width: 50px;
                height: 50px;
            }
            .path {
                stroke: #fc5659!important;
            }
        }

        .live-frame {
            width: 100%;
            height: 100%;
            .vhall-share {
                display: none;
            }
        }

        .error {
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 22px;
            color: #ccc;
            letter-spacing: 2px;
            user-select: none;
            .nucfont {
                font-size: 24px;
                margin-right: 6px;
            }

            .btn-refresh {
                display: block;
                margin-top: 50px;
                text-align: center;
                cursor: pointer;
                color: $blue;
                .refresh-icon {
                    font-size: 40px;
                }
            }
        }
    }

</style>
